/**
 * Fetches a PDF into memory and returns an object URL for it, so the in-app
 * PDF viewer (the one Save in Documents opens) can show a PDF that was
 * generated on the fly and isn't a stored Document. Caller revokes it
 * (URL.revokeObjectURL) once the viewer closes.
 */
export async function fetchPdfAsObjectUrl(url: string): Promise<string> {
  const response = await fetch(url);
  if (!response.ok) {
    // The backend explains failures as JSON ({ error: "…" }) — surface that text.
    let detail = '';
    try {
      detail = (await response.json())?.error ?? '';
    } catch {
      /* not JSON */
    }
    throw new Error(detail || `HTTP ${response.status}`);
  }
  const blob = await response.blob();
  return URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
}
